export default {
  getCurrentUser(state) {
    return {
      email: state.user.email,
      name: state.user.name,
      phone: state.user.phone,
      token: state.user.token,
    };
  },
  hasGuestDetails(state) {
    return state.user.email && state.user.name && state.user.phone;
  },
  getPaymentOptions(state) {
    return {
      ...state.requiredCheckoutData,
    };
  },
  getEcomTrackingData(state) {
    return {
      ...state.requiredCheckoutData,
      ...state.successData,
    };
  },
  getBasketTotal(state) {
    return state.requiredCheckoutData.basketTotal || 0;
  },
  getPromotionDiscountAmount(state) {
    return state.requiredCheckoutData.promotionDiscount || 0;
  },
  getSuccessData(state) {
    return state.successData;
  },
  getVoucherDiscountAmount(state) {
    return state.requiredCheckoutData.voucherDiscount || 0;
  },
  getVoucherDetail(state) {
    return state.voucherDetail;
  },
  getOrderNumber(state) {
    return state.orderNumber;
  },
};
